export default __webpack_public_path__ + "static/media/checklistComplete.0f756c80.svg";